import { useField } from "formik";
import { FC } from "react";
import { SwitchInput, SwitchInputProps } from "./SwitchInput";

interface Props extends Omit<SwitchInputProps, "value" | "onChange"> {
  name: string;
}

const SwitchField: FC<Props> = ({ name, ...switchInputProps }) => {
  const [field, , { setValue }] = useField<boolean>(name);

  return <SwitchInput {...field} onChange={setValue} {...switchInputProps} />;
};

export { SwitchField };
